import React from "react";

import { Typography, Box, List } from "@mui/material";
import { CheckBold as TickIcon } from "@tiny/icons";
import { FeatureListProps, Feature } from "./FeaturesList.types";

function RequirementList(props: FeatureListProps) {
  const { list, component = "ul", ...other } = props;

  return (
    <Box
      {...other}
      component={component}
      sx={{
        display: "flex",
        flexWrap: "wrap",
        listStyle: "none",
        justifyContent: "space-between",
        padding: 0,
      }}
    >
      {list.map((item, index) => (
        <List
          key={index}
          sx={{
            display: "flex",
            paddingTop: "12px",
            alignItems: "center",
            gap: 1,
            pb: 0,
          }}
        >
          <TickIcon
            color={item.enabled ? "primary" : "disabled"}
            sx={{
              fontSize: 16,
            }}
          />
          <Typography variant="p2" color="grey" fontWeight="regular">
            {item.name}
          </Typography>
        </List>
      ))}
    </Box>
  );
}

export default RequirementList;
